import { useState } from 'react';
import useAsyncEffect from '../../../../../../packages/hooks/src/useAsyncEffect';
import { getGeoIP } from '../../../../modules/consumer/DeviceLocation';
import { toSlugCase } from '../../../../modules/stringUtils';

export type UseMetroAreaData = {
  metroArea: string;
};

export const useMetroArea = (): UseMetroAreaData => {
  const [metroArea, setMetroArea] = useState(null);

  useAsyncEffect(async () => {
    const location = await getGeoIP();
    setMetroArea(toSlugCase(location?.metro_area || '') || null);
  }, []);

  return {
    metroArea,
  };
};
